import axiosInstance from "./axiosIntercept";

export const fetchShowOrgOptionAllowlist = async (): Promise<string[]> => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_URL}v1/configuration/show-org-option-to`,
    {
      withCredentials: true,
      headers: { "api-key": process.env.REACT_APP_API_KEY },
    },
  );

  if (response.data?.success && Array.isArray(response.data?.data?.value)) {
    return response.data.data.value
      .filter((email: unknown): email is string => typeof email === "string")
      .map((email: string) => email.trim())
      .filter(Boolean);
  }

  return [];
};

export const isUserInShowOrgOptionAllowlist = (
  userEmail: string,
  allowedEmails: string[],
): boolean => {
  const normalizedEmail = userEmail.trim().toLowerCase();
  return allowedEmails.some(
    (email) => email.trim().toLowerCase() === normalizedEmail,
  );
};
